import { NgModule } from '@angular/core';

import { CriticalMessageComponent }         from './critical-message.component';
import { CriticalMessagesActionsComponent } from './critical-messages.actions.component';
import { CriticalMessagesComponent }        from './critical-messages.component';
import { CriticalMessagesService }          from './critical-messages.service';
import { SharedModule }                     from '../../shared/shared.module';
import { TableModule }                      from '../../table/table.module';
import { VerifyCriticalMessageComponent }   from './critical-messages.verify.component';

@NgModule({
  declarations: [
    CriticalMessageComponent,
    CriticalMessagesComponent,
    CriticalMessagesActionsComponent,
    VerifyCriticalMessageComponent
  ],
  entryComponents: [
    CriticalMessageComponent,
    CriticalMessagesComponent,
    CriticalMessagesActionsComponent,
    VerifyCriticalMessageComponent
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  providers: [
    CriticalMessagesService
  ]
})
export class CriticalMessagesModule {}
